<span class="validation-error" *ngIf="firstErrorKey">
  {{ errorMessages[firstErrorKey] }}
</span>
